/**
 * Mapa central de imagens do projeto.
 * Importa todas as imagens necessárias estaticamente.
 */

// Logos
import logoOlivasDigital from '../assets/images/logo_olivas_digital.png';

// Logos 2026
import logoPadocaria26 from '../assets/images/logos/logo-padocaria-26.webp';
import logoPadocariaSP26 from '../assets/images/logos/logo-padocaria-sp-26.webp';
import logoPadocariaBH26 from '../assets/images/logos/logo-padocaria-bh-26.webp';

// Ícones de localização
import iconBrasil from '../assets/images/icon_brasil.png';
import iconSp from '../assets/images/icon_sp.png';
import iconSpBig from '../assets/images/icon_sp_big.png';
import iconSpLove from '../assets/images/icon_sp_love.png';

// Ícones gerais
import iconChat from '../assets/images/icon_chat.png';
import iconFacebook from '../assets/images/icon_facebook.png';
import iconInstagram from '../assets/images/icon_instagram.png';
import iconCheck from '../assets/images/icon_check.png';
import iconCalendar from '../assets/images/icon_calendar.png';
import iconFirst from '../assets/images/icon_first.png';
import iconStep1 from '../assets/images/icon_step_1.png';
import iconStep2 from '../assets/images/icon_step_2.png';
import iconStepAward from '../assets/images/icon_step_award.png';
import iconTrigo from '../assets/images/icon_trigo.png';
import iconSearch from '../assets/images/icon_search.png';
import iconLocation from '../assets/images/icon_location.png';
import iconGoogle from '../assets/images/icon_google.png';
import iconClose from '../assets/images/icon_close.png';

// Imagens de categorias
import imageCafezinho from '../assets/images/image_cafezinho.png';
import imageFermentacaoNatural from '../assets/images/image_fermentacao_natural.jpg';
import imageChapeiro from '../assets/images/image_chapeiro.png';
import imagePaoNaChapa from '../assets/images/image_paonachapa.png';
import imagePaozinho from '../assets/images/image_paozinho.png';
import imageFolhado from '../assets/images/image-folhado.jpg';
import imagePizza from '../assets/images/image_pizza.png';
import imagePadaria from '../assets/images/image_padaria.png';
import imageFlip from '../assets/images/image_flip.png';
import imageFrios from '../assets/images/image_frios.png';
import imageDoce from '../assets/images/image_doce.jpg';
import imageAlmoco from '../assets/images/almoco.webp';
import imageVitrineDoces from '../assets/images/vitrine-doces.webp';

// Banners Fixos 2026
import bannerMondelezVideo26 from '../assets/images/banners/2026/fixos/mondelez.mp4';
import bannerCatupiry26 from '../assets/images/banners/2026/fixos/catupiry.webp';
import bannerGetnet26 from '../assets/images/banners/2026/fixos/getnet.webp';
import bannerNita26 from '../assets/images/banners/2026/fixos/nita.webp';

// Banners Rotativos 2026
import bannerFoodToSave26 from '../assets/images/banners/2026/rotativos/food-to-save.png';
import bannerIpEmbalagens26 from '../assets/images/banners/2026/rotativos/ip-embalagens.jpg';
import bannerSindipan26 from '../assets/images/banners/2026/rotativos/sindipan.png';

// Backgrounds
import bgPadocaria from '../assets/images/bg_padocaria.png';
import bgContest from '../assets/images/bg_contest.png';
import bgStep from '../assets/images/bg_step.png';
import bgOutrasEdicoes from '../assets/images/bg-outras-edicoes.webp';

// Troféu
import iconTrofeu from '../assets/images/categorias/trofeu-padocaria.webp';

// Ícones de categorias para Premiação
import catAtendimento from '../assets/images/categorias/melhor-atendimento.webp';
import catBolo from '../assets/images/categorias/melhor-bolo.webp';
import catBroinha from '../assets/images/categorias/melhor-broinha.webp';
import catCafeNutella from '../assets/images/categorias/melhor-cafe-com-nutella.webp';
import catCafe from '../assets/images/categorias/melhor-cafe.webp';
import catDoce from '../assets/images/categorias/melhor-doce.webp';
import catFatiadorFrios from '../assets/images/categorias/melhor-fatiador-de-frios.webp';
import catFolhado from '../assets/images/categorias/melhor-folhado.webp';
import catFrangoAssado from '../assets/images/categorias/melhor-frango-assado.webp';
import catPaoFermentacaoNatural from '../assets/images/categorias/melhor-pao-fermentacao-natural.webp';
import catPaoNaChapaCatupiry from '../assets/images/categorias/melhor-pao-na-chapa-catupiry.webp';
import catPaoNaChapa from '../assets/images/categorias/melhor-pao-na-chapa.webp';
import catPaoDeQueijo from '../assets/images/categorias/melhor-pao-de-queijo.webp';
import catPaozinho from '../assets/images/categorias/melhor-paozinho.webp';
import catPizza from '../assets/images/categorias/melhor-pizza.webp';
import catSanduba from '../assets/images/categorias/melhor-sanduba.webp';
import catSonho from '../assets/images/categorias/melhor-sonho.webp';
import catTimeChapeirosV1 from '../assets/images/categorias/melhor-time-de-chapeiros-v1.webp';
import catTimeChapeirosV2 from '../assets/images/categorias/melhor-time-de-chapeiros-v2.webp';
import catPadaria from '../assets/images/categorias/melhor-padaria.webp';
import catPadariaGuarulhos from '../assets/images/categorias/melhor-padaria-guarulhos.webp';
import catPadariaSustentavel from '../assets/images/categorias/melhor-padaria-sustentavel.webp';
import catPadariaSPEstado from '../assets/images/categorias/melhor-padaria-sp-estado.webp';
import catPadariaSPCoracao from '../assets/images/categorias/melhor-padaria-sp-coracao.webp';
import catPadariaSPTrofeu from '../assets/images/categorias/melhor-padaria-sp-trofeu.webp';
import catPadariaBHEstado from '../assets/images/categorias/melhor-padaria-bh-estado.webp';
import catPadariaBHCoracao from '../assets/images/categorias/melhor-padaria-bh-coracao.webp';
import catPadariaBHTrofeu from '../assets/images/categorias/melhor-padaria-bh-trofeu.webp';
import mapaRegioesBH from '../assets/images/categorias/mapa-regioes-padocaria-bh.webp';
import mapaRegioesBHWithBg from '../assets/images/categorias/mapa-regioes-padocaria-bh-with-bg.webp';

// Régua de Logos BH 2026
import logoAmipao from '../assets/images/regua-logos/bh-2026/amipao.webp';
import logoBelotur from '../assets/images/regua-logos/bh-2026/belotour.webp';
import logoCdlFm from '../assets/images/regua-logos/bh-2026/cdl-fm.webp';
import logoFoodToSaveBH from '../assets/images/regua-logos/bh-2026/food-to-save.webp';
import logoFredizak from '../assets/images/regua-logos/bh-2026/fredizak.webp';
import logoGetnet from '../assets/images/regua-logos/bh-2026/getnet.webp';
import logoIel from '../assets/images/regua-logos/bh-2026/iel.webp';
import logoIpBH from '../assets/images/regua-logos/bh-2026/ip-embalagens.webp';
import logoKrug from '../assets/images/regua-logos/bh-2026/krug.webp';
import logoPrefeituraBH from '../assets/images/regua-logos/bh-2026/prefeitura.webp';
import logoSebrae from '../assets/images/regua-logos/bh-2026/sebrae.webp';

// Régua de Logos SP 2026
import logoMondelezSP from '../assets/images/regua-logos/sp-2026/mondelez.webp';
import logoCatupirySP from '../assets/images/regua-logos/sp-2026/catupiry.webp';
import logoGetnetSP from '../assets/images/regua-logos/sp-2026/getnet.webp';
import logoSearaSP from '../assets/images/regua-logos/sp-2026/seara.webp';
import logoNitaSP from '../assets/images/regua-logos/sp-2026/nita.webp';
import logoIpSP from '../assets/images/regua-logos/sp-2026/ip-embalagens.webp';
import logoSindipanSP from '../assets/images/regua-logos/sp-2026/sindipan.webp';
import logoFoodToSaveSP from '../assets/images/regua-logos/sp-2026/food-to-save.webp';
import logoBandNewsSP from '../assets/images/regua-logos/sp-2026/bandnews.webp';

// Banners de publicidade

const imagensMap = {
  'logo_olivas_digital.png': logoOlivasDigital,

  'logos/logo-padocaria-26.webp': logoPadocaria26,
  'logos/logo-padocaria-sp-26.webp': logoPadocariaSP26,
  'logos/logo-padocaria-bh-26.webp': logoPadocariaBH26,

  'icon_brasil.png': iconBrasil,
  'icon_sp.png': iconSp,
  'icon_sp_big.png': iconSpBig,
  'icon_sp_love.png': iconSpLove,

  'icon_chat.png': iconChat,
  'icon_facebook.png': iconFacebook,
  'icon_instagram.png': iconInstagram,
  'icon_check.png': iconCheck,
  'icon_calendar.png': iconCalendar,
  'icon_first.png': iconFirst,
  'icon_step_1.png': iconStep1,
  'icon_step_2.png': iconStep2,
  'icon_step_award.png': iconStepAward,
  'icon_trigo.png': iconTrigo,
  'icon_search.png': iconSearch,
  'icon_location.png': iconLocation,
  'icon_google.png': iconGoogle,
  'icon_close.png': iconClose,

  'image_cafezinho.png': imageCafezinho,
  'image_fermentacao_natural.jpg': imageFermentacaoNatural,
  'image_chapeiro.png': imageChapeiro,
  'image_paonachapa.png': imagePaoNaChapa,
  'image_paozinho.png': imagePaozinho,
  'image-folhado.jpg': imageFolhado,
  'image_pizza.png': imagePizza,
  'image_padaria.png': imagePadaria,
  'image_flip.png': imageFlip,
  'image_frios.png': imageFrios,
  'image_doce.jpg': imageDoce,
  'almoco.webp': imageAlmoco,
  'ALMOCO.webp': imageAlmoco,
  'ALMOÇO.webp': imageAlmoco,
  'vitrine-doces.webp': imageVitrineDoces,
  'VITRINE_DOCES.webp': imageVitrineDoces,

  'bg_padocaria.png': bgPadocaria,
  'bg_contest.png': bgContest,
  'bg_step.png': bgStep,
  'bg-outras-edicoes.webp': bgOutrasEdicoes,
  'categorias/trofeu-padocaria.webp': iconTrofeu,

  'categorias/melhor-atendimento.webp': catAtendimento,
  'categorias/melhor-bolo.webp': catBolo,
  'categorias/melhor-broinha.webp': catBroinha,
  'categorias/melhor-cafe-com-nutella.webp': catCafeNutella,
  'categorias/melhor-cafe.webp': catCafe,
  'categorias/melhor-doce.webp': catDoce,
  'categorias/melhor-fatiador-de-frios.webp': catFatiadorFrios,
  'categorias/melhor-folhado.webp': catFolhado,
  'categorias/melhor-frango-assado.webp': catFrangoAssado,
  'categorias/melhor-pao-fermentacao-natural.webp': catPaoFermentacaoNatural,
  'categorias/melhor-pao-na-chapa-catupiry.webp': catPaoNaChapaCatupiry,
  'categorias/melhor-pao-na-chapa.webp': catPaoNaChapa,
  'categorias/melhor-pao-de-queijo.webp': catPaoDeQueijo,
  'categorias/melhor-paozinho.webp': catPaozinho,
  'categorias/melhor-pizza.webp': catPizza,
  'categorias/melhor-sanduba.webp': catSanduba,
  'categorias/melhor-sonho.webp': catSonho,
  'categorias/melhor-time-de-chapeiros-v1.webp': catTimeChapeirosV1,
  'categorias/melhor-time-de-chapeiros-v2.webp': catTimeChapeirosV2,
  'categorias/melhor-padaria.webp': catPadaria,
  'categorias/melhor-padaria-guarulhos.webp': catPadariaGuarulhos,
  'categorias/melhor-padaria-sustentavel.webp': catPadariaSustentavel,
  'categorias/melhor-padaria-sp-estado.webp': catPadariaSPEstado,
  'categorias/melhor-padaria-sp-coracao.webp': catPadariaSPCoracao,
  'categorias/melhor-padaria-sp-trofeu.webp': catPadariaSPTrofeu,
  'categorias/melhor-padaria-bh-estado.webp': catPadariaBHEstado,
  'categorias/melhor-padaria-bh-coracao.webp': catPadariaBHCoracao,
  'categorias/melhor-padaria-bh-trofeu.webp': catPadariaBHTrofeu,
  'categorias/mapa-regioes-padocaria-bh.webp': mapaRegioesBH,
  'categorias/mapa-regioes-padocaria-bh-with-bg.webp': mapaRegioesBHWithBg,

  'regua-logos/bh-2026/amipao.webp': logoAmipao,
  'regua-logos/bh-2026/belotour.webp': logoBelotur,
  'regua-logos/bh-2026/cdl-fm.webp': logoCdlFm,
  'regua-logos/bh-2026/food-to-save.webp': logoFoodToSaveBH,
  'regua-logos/bh-2026/fredizak.webp': logoFredizak,
  'regua-logos/bh-2026/getnet.webp': logoGetnet,
  'regua-logos/bh-2026/iel.webp': logoIel,
  'regua-logos/bh-2026/ip-embalagens.webp': logoIpBH,
  'regua-logos/bh-2026/krug.webp': logoKrug,
  'regua-logos/bh-2026/prefeitura.webp': logoPrefeituraBH,
  'regua-logos/bh-2026/sebrae.webp': logoSebrae,

  'regua-logos/sp-2026/mondelez.webp': logoMondelezSP,
  'regua-logos/sp-2026/catupiry.webp': logoCatupirySP,
  'regua-logos/sp-2026/getnet.webp': logoGetnetSP,
  'regua-logos/sp-2026/seara.webp': logoSearaSP,
  'regua-logos/sp-2026/nita.webp': logoNitaSP,
  'regua-logos/sp-2026/ip-embalagens.webp': logoIpSP,
  'regua-logos/sp-2026/sindipan.webp': logoSindipanSP,
  'regua-logos/sp-2026/food-to-save.webp': logoFoodToSaveSP,
  'regua-logos/sp-2026/bandnews.webp': logoBandNewsSP,

  'banners/2026/fixos/mondelez.mp4': bannerMondelezVideo26,
  'banners/2026/fixos/catupiry.webp': bannerCatupiry26,
  'banners/2026/fixos/getnet.webp': bannerGetnet26,
  'banners/2026/fixos/nita.webp': bannerNita26,

  'banners/2026/rotativos/food-to-save.png': bannerFoodToSave26,
  'banners/2026/rotativos/ip-embalagens.jpg': bannerIpEmbalagens26,
  'banners/2026/rotativos/sindipan.png': bannerSindipan26
};

let imagesContext = null;
try {
  imagesContext = require.context(
    '../assets/images',
    true,
    /\.(png|jpe?g|svg|webp|mp4|webm|gif)$/
  );
} catch (e) {
  // Ignorar
}

/**
 * Retorna a imagem correspondente ao nome do arquivo.
 * @param {string} nomeArquivo - Nome do arquivo no mapa ou caminho relativo
 * @returns {string|null} - URL/Módulo da imagem ou null se não encontrada
 */
export const getImagem = (nomeArquivo) => {
  if (!nomeArquivo) return null;
  if (imagensMap[nomeArquivo]) {
    return imagensMap[nomeArquivo];
  }
  if (imagesContext) {
    try {
      const cleanPath = nomeArquivo.startsWith('./')
        ? nomeArquivo
        : `./${nomeArquivo}`;
      const asset = imagesContext(cleanPath);
      return asset?.default || asset || null;
    } catch (e) {
      // Arquivo não encontrado
    }
  }
  return null;
};

export default imagensMap;
